import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="batch-collection"
export default class extends Controller {
  static targets = ['button', 'idsField', 'count', 'checkbox']

  connect () {
    this.#updateFromCheckboxes()
  }

  toggle (_event) {
    this.#updateFromCheckboxes()
  }

  checkboxTargetDisconnected () {
    this.#updateFromCheckboxes()
  }

  #updateFromCheckboxes () {
    let count = 0
    const ids = []

    this.checkboxTargets.forEach(checkbox => {
      if (checkbox.checked) {
        count++
        ids.push(checkbox.value)
      }
    })

    if (count > 0) {
      this.buttonTarget.removeAttribute('disabled')
      this.countTarget.textContent = `(${count})`
      this.countTarget.classList.remove('hidden')
    } else {
      this.buttonTarget.setAttribute('disabled', 'disabled')
      this.countTarget.classList.add('hidden')
    }

    this.idsFieldTarget.value = ids.join(',')
  }
}
